module.exports = __webpack_public_path__ + "media/images/riders/small/STEPHANE_TEMPIER-7ccbd839904db2730dbeac8c90bff9af.png";